import React from 'react';

interface ImageGridProps {
  images: string[];
  onImageClick: (images: string[], index: number) => void;
  altDescription: string;
}

function ImageGrid({images, onImageClick, altDescription}: ImageGridProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-w-5xl mx-auto mt-8 px-4">
      {images.map((image, index) => (
        <div key={index} className="aspect-[4/3] overflow-hidden cursor-pointer group" onClick={() => onImageClick(images,index)}>
          <img className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" src={image} alt={altDescription}/>
        </div>
      ))}
    </div>
  );
}

export default ImageGrid;
